<div class="estimate-cta">
  <div class="estimate-cta__container">
    <div class="estimate-cta__new-container">
      <div class="estimate-cta__new">
          {{ 'home-estimator.new' | translate }}
        </div>
    </div>

    <div class="estimate-cta__heading">
        {{ 'home-estimator.heading-1' | translate }} <br/> {{ 'home-estimator.heading-2' | translate }}
    </div>
    <a class="estimate-cta__link btn-redesign--home" (click)="onNavigate()" routerLink="/home-estimates-canada">
      {{ 'home-estimator.cta-button' | translate }}
    </a>
  </div>
</div>
